
import { defineComponent, onMounted, PropType, reactive, toRefs, watchEffect } from 'vue'
import { detectEnvironment } from '@/utils/browser/detect'
import { getRequestLanguage } from '@/api/utils'

export default defineComponent({
  name: 'BrowserGuide',
  props: {
    // 是否显示分享提示
    show: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    // 点击关闭事件
    onClose: {
      type: Function as PropType<() => void>,
      default: null
    },
    // 是否启用自动检测浏览器环境
    enableAutoDetect: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:show'],
  setup(props, { emit }) {
    const state = reactive<{
      isShowOverlay: boolean
    }>({
      isShowOverlay: props.show
    })

    watchEffect(() => {
      state.isShowOverlay = props.show
    })

    const close = () => {
      if (props.onClose && typeof props.onClose === 'function') {
        props.onClose()
        return
      }
      emit('update:show', false)
      state.isShowOverlay = false
    }

    onMounted(() => {
      if (getRequestLanguage() === 'ar') {
        document.documentElement.setAttribute('dir', 'rtl')
      }
      if (props.enableAutoDetect) {
        // 如果不在白名单，显示引导层
        state.isShowOverlay = !detectEnvironment()
      }
    })

    return {
      ...toRefs(state),
      close
    }
  }
})
